export const APP_NAME = 'identification_perseus';

export const ROLLOUTS = {
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 'lynxes_identification_core_reset_password_flow',
} as const;

export const EXPERIMENTS = {
    LYNXES_IDENTIFICATION_RESET_PASSWORD_STEP: 4833,
} as const;
